/**
 * UNIVAPLAT-2771: command (write) models for the admin license deactivation endpoints
 * (backend contract UNIVAPLAT-2756).
 *
 * The reason is PHI-adjacent — never log it (Sentry breadcrumbs included).
 */

/**
 * Maximum length accepted by the backend for a deactivation reason.
 * Longer values are rejected with HTTP 422 (`deactivation_reason_too_long`).
 * Use this constant for form validators in the admin UI.
 */
export const DEACTIVATION_REASON_MAX_LENGTH = 100;

/**
 * Body of `POST /api/v2/admin/users/{userId}/license/deactivate`.
 * `reason` is optional; absent deactivates without a recorded reason.
 */
export interface UserLicenseDeactivate {
    reason?: string,
}

/**
 * Body of `PATCH /api/v2/admin/users/{userId}/license/{licenseId}/deactivation-reason`.
 */
export interface UserLicenseDeactivationReasonUpdate {
    reason: string,
}
